import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { getCountryCodeFromLocale } from '../../utils/consumer'
import { getPortalMigrationEnabledFromCookie } from '../../utils/convergence'
import { getPortalMigrationEnabledCountry } from '../../model/convergence'
import { useFlag, LaunchDarklyFlags } from '../useFlag'

/**
 * Hook to determine if portal migration is enabled
 *
 * Logic:
 * 1. Check if country is in the enabled countries list
 * 2. If country is not enabled, return false
 * 3. If country is enabled, check the cookie value
 * 4. If cookie is true, return true
 * 5. If cookie is undefined or false, check the feature flag
 * 6. Return true if feature flag is 'A', otherwise false
 */
export const usePortalMigrationEnabled = (): boolean => {
  const router = useRouter()
  const { locale } = router
  const country = getCountryCodeFromLocale(locale)

  // Get login migration variant flag
  const loginMigrationVariant = useFlag(LaunchDarklyFlags.LoginMigration, 'C')

  const isEnabled = useMemo(() => {
    // Get enabled countries
    const portalMigrationEnabledCountry = getPortalMigrationEnabledCountry()

    // Check if current country is in enabled list
    const isCountryEnabled = portalMigrationEnabledCountry.includes(country)

    if (!isCountryEnabled) {
      return false
    }

    // Get cookie value
    const cookieValue = getPortalMigrationEnabledFromCookie()

    // If cookie is true, return true
    if (cookieValue) {
      return true
    }

    // If cookie is false or undefined, check feature flag

    // Return true if feature flag is 'A'
    const isFlagA = loginMigrationVariant === 'A'

    return isFlagA
  }, [country, loginMigrationVariant])

  return isEnabled
}
